// Apartment instruction data and translations
const APARTMENT_DATA = {
  suite: {
    name: 'Suite Apartment',
    code: '0126',
    safeboxImage: 'https://customer-assets.emergentagent.com/job_homewise-ticino/artifacts/unr0jh2g_6.jpeg',
    mapsLink: 'https://maps.app.goo.gl/m97jDayybzTcExBZA?g_st=ac',
    parkingMapsLink: 'https://maps.app.goo.gl/LqUoLuyNh1QfMFhYA',
    photos: [
      'https://customer-assets.emergentagent.com/job_homewise-ticino/artifacts/n893u6k0_1.jfif',
      'https://customer-assets.emergentagent.com/job_homewise-ticino/artifacts/gykq1htx_2.jfif',
      'https://customer-assets.emergentagent.com/job_homewise-ticino/artifacts/zi64vlm9_3.jfif',
      'https://customer-assets.emergentagent.com/job_homewise-ticino/artifacts/mwmrcyp1_4.jfif',
      'https://customer-assets.emergentagent.com/job_homewise-ticino/artifacts/wdecrdnt_5.jfif',
    ],
    instructions: {
      it: {
        address: 'Via Carona 41, 6912 Pazzallo',
        warning: 'ATTENZIONE: esiste lo stesso indirizzo e numero civico a Paradiso (il paese è molto vicino), ma il villaggio corretto è PAZZALLO, NON Paradiso.',
        checkin: 'Il check-in è possibile a partire dalle ore 15:00.',
        parking: 'Se desideri utilizzare il parcheggio privato coperto, che si trova a 5 minuti a piedi, ecco la posizione esatta. Tieni presente che non è chiuso con chiave e non bisogna forzare il garage quando lo si chiude. In alternativa, molto vicino all\'appartamento (appena sopra nella via) c\'è un parcheggio pubblico (con orari limitati).',
        transport: 'Puoi anche prendere il bus 434 (fermata "Pazzallo, Ai Ronchi") che si trova 30 metri sopra l\'appartamento nella via e impiega 10 minuti per raggiungere il centro di Lugano.',
      },
      en: {
        address: 'Via Carona 41, 6912 Pazzallo',
        warning: 'PLEASE PAY ATTENTION: there is the same address and number in Paradiso (the village is very close to the right one), but the right village is PAZZALLO, NOT Paradiso.',
        checkin: 'You can check-in starting from 3 PM.',
        parking: 'If you would like to use the private indoor parking, which is 5 minutes away on foot, here is the precise location. Please be aware that it is not closed with keys and you should not force the garage when closing it. Alternatively, very close to the apartment (just above in the street) there is a public parking (with restricted hours).',
        transport: 'You can also take bus 434 (bus station "Pazzallo, Ai Ronchi") which is 30 meters above the apartment in the street and it takes 10 minutes to Lugano center.',
      },
      de: {
        address: 'Via Carona 41, 6912 Pazzallo',
        warning: 'BITTE BEACHTEN: Es gibt die gleiche Adresse und Hausnummer in Paradiso (das Dorf liegt sehr nahe), aber das richtige Dorf ist PAZZALLO, NICHT Paradiso.',
        checkin: 'Der Check-in ist ab 15:00 Uhr möglich.',
        parking: 'Wenn Sie den privaten Innenparkplatz nutzen möchten, der 5 Gehminuten entfernt ist, finden Sie hier die genaue Position. Bitte beachten Sie, dass er nicht abgeschlossen ist und Sie das Garagentor beim Schließen nicht forcieren sollten. Alternativ gibt es sehr nahe der Wohnung (etwas oberhalb in der Straße) einen öffentlichen Parkplatz (mit eingeschränkten Zeiten).',
        transport: 'Sie können auch den Bus 434 (Haltestelle "Pazzallo, Ai Ronchi") nehmen, der sich 30 Meter oberhalb der Wohnung in der Straße befindet und 10 Minuten bis ins Zentrum von Lugano braucht.',
      },
      fr: {
        address: 'Via Carona 41, 6912 Pazzallo',
        warning: 'ATTENTION: il existe la même adresse et le même numéro à Paradiso (le village est très proche), mais le bon village est PAZZALLO, PAS Paradiso.',
        checkin: 'L\'enregistrement est possible à partir de 15h00.',
        parking: 'Si vous souhaitez utiliser le parking privé couvert, situé à 5 minutes à pied, voici la position exacte. Veuillez noter qu\'il n\'est pas fermé à clé et qu\'il ne faut pas forcer le garage en le fermant. Alternativement, très proche de l\'appartement (juste au-dessus dans la rue) il y a un parking public (avec des horaires restreints).',
        transport: 'Vous pouvez aussi prendre le bus 434 (arrêt "Pazzallo, Ai Ronchi") qui se trouve 30 mètres au-dessus de l\'appartement dans la rue et met 10 minutes pour rejoindre le centre de Lugano.',
      },
    },
  },
  bellavista: {
    name: 'Bellavista',
    code: '0226',
    safeboxImage: 'https://customer-assets.emergentagent.com/job_homewise-ticino/artifacts/jt42l5vh_WhatsApp%20Image%202026-06-14%20at%2021.48.48.jpeg',
    mapsLink: 'https://maps.app.goo.gl/g8V3TkBzeMTFjUHa7?g_st=aw',
    parkingMapsLink: '',
    photos: [
      'https://customer-assets.emergentagent.com/job_homewise-ticino/artifacts/5n7m0nhu_WhatsApp%20Image%202026-06-14%20at%2021.48.50.jpeg',
      'https://customer-assets.emergentagent.com/job_homewise-ticino/artifacts/vxpt1g8e_WhatsApp%20Image%202026-06-14%20at%2021.48.49.jpeg',
      'https://customer-assets.emergentagent.com/job_homewise-ticino/artifacts/5e4s2285_WhatsApp%20Image%202026-06-14%20at%2021.48.36.jpeg',
    ],
    instructions: {
      it: {
        address: 'Via Carona 34, 6912 Pazzallo',
        warning: 'ATTENZIONE: esiste lo stesso indirizzo e numero civico a Paradiso (il paese è molto vicino), ma il villaggio corretto è PAZZALLO, NON Paradiso.',
        checkin: 'Il check-in è possibile a partire dalle ore 15:00.',
        parking: 'Il parcheggio coperto è direttamente sul posto, all\'ingresso dell\'appartamento. Vedi tutte le foto allegate con le istruzioni. In alternativa, molto vicino all\'appartamento (appena sopra nella via) c\'è un parcheggio pubblico (con orari limitati).',
        transport: 'Puoi anche prendere il bus 434 (fermata "Pazzallo, Ai Ronchi") che si trova 30 metri sopra l\'appartamento nella via e impiega 10 minuti per raggiungere il centro di Lugano.',
      },
      en: {
        address: 'Via Carona 34, 6912 Pazzallo',
        warning: 'PLEASE PAY ATTENTION: there is the same address and number in Paradiso (the village is very close to the right one), but the right village is PAZZALLO, NOT Paradiso.',
        checkin: 'You can check-in starting from 3 PM.',
        parking: 'The covered parking is directly on site, at the entrance of the apartment. See all pictures attached with all instructions. Alternatively, very close to the apartment (just above in the street) there is a public parking (with restricted hours).',
        transport: 'You can also take bus 434 (bus station "Pazzallo, Ai Ronchi") which is 30 meters above the apartment in the street and it takes 10 minutes to Lugano center.',
      },
      de: {
        address: 'Via Carona 34, 6912 Pazzallo',
        warning: 'BITTE BEACHTEN: Es gibt die gleiche Adresse und Hausnummer in Paradiso (das Dorf liegt sehr nahe), aber das richtige Dorf ist PAZZALLO, NICHT Paradiso.',
        checkin: 'Der Check-in ist ab 15:00 Uhr möglich.',
        parking: 'Der überdachte Parkplatz befindet sich direkt vor Ort, am Eingang der Wohnung. Sehen Sie alle Fotos mit Anweisungen. Alternativ gibt es sehr nahe der Wohnung (etwas oberhalb in der Straße) einen öffentlichen Parkplatz (mit eingeschränkten Zeiten).',
        transport: 'Sie können auch den Bus 434 (Haltestelle "Pazzallo, Ai Ronchi") nehmen, der sich 30 Meter oberhalb der Wohnung in der Straße befindet und 10 Minuten bis ins Zentrum von Lugano braucht.',
      },
      fr: {
        address: 'Via Carona 34, 6912 Pazzallo',
        warning: 'ATTENTION: il existe la même adresse et le même numéro à Paradiso (le village est très proche), mais le bon village est PAZZALLO, PAS Paradiso.',
        checkin: 'L\'enregistrement est possible à partir de 15h00.',
        parking: 'Le parking couvert est directement sur place, à l\'entrée de l\'appartement. Voir toutes les photos jointes avec les instructions. Alternativement, très proche de l\'appartement (juste au-dessus dans la rue) il y a un parking public (avec des horaires restreints).',
        transport: 'Vous pouvez aussi prendre le bus 434 (arrêt "Pazzallo, Ai Ronchi") qui se trouve 30 mètres au-dessus de l\'appartement dans la rue et met 10 minutes pour rejoindre le centre de Lugano.',
      },
    },
  },
  oasis: {
    name: 'Oasis Apartment',
    code: '0326',
    safeboxImage: 'https://customer-assets.emergentagent.com/job_homewise-ticino/artifacts/6eeydn44_2.jfif',
    mapsLink: 'https://maps.app.goo.gl/k5ovvN9HPvciaC5z6',
    parkingMapsLink: '',
    photos: [
      'https://customer-assets.emergentagent.com/job_homewise-ticino/artifacts/q5hi0aeb_1.jfif',
      'https://customer-assets.emergentagent.com/job_homewise-ticino/artifacts/4nsamxhx_3.jfif',
      'https://customer-assets.emergentagent.com/job_homewise-ticino/artifacts/vkbopvqv_4.jfif',
    ],
    instructions: {
      it: {
        address: 'Via Loco 15A, 6963 Pregassona',
        warning: '',
        checkin: 'Il check-in è possibile a partire dalle ore 15:00.',
        parking: 'Se hai bisogno di parcheggiare l\'auto, un parcheggio privato coperto (garage) è disponibile sul posto. Se chiudi completamente il garage, dovrai aprirlo con le chiavi. Le chiavi del garage sono insieme a quelle dell\'appartamento. Il garage è alto 2 metri e largo 2,30 metri. In alternativa, molto vicino all\'appartamento (appena sopra nella via) ci sono parcheggi pubblici blu (con orari limitati).',
        transport: 'Puoi anche prendere il bus nr. 7 da "Pregassona, Viarnetto" o "Pregassona, Piazza di giro" che si trova a 5 minuti a piedi e impiega 10 minuti per raggiungere il centro di Lugano. Le corse partono ogni 15 minuti.',
      },
      en: {
        address: 'Via Loco 15A, 6963 Pregassona',
        warning: '',
        checkin: 'You can check-in starting from 3 PM.',
        parking: 'If you need to park the car, a private indoor parking (garage) is available on site. If you completely close the garage, you will need to open it with the keys. Garage keys are together with the apartment keys. The garage is 2 meters high and 2.30 meters wide. Alternatively, very close to the apartment (just above in the street) there are blue public parking spots (with restricted hours).',
        transport: 'You can also take bus nr. 7 from "Pregassona, Viarnetto" or "Pregassona, Piazza di giro" which is 5 minutes by foot and it takes 10 minutes to Lugano center. Runs go every 15 minutes.',
      },
      de: {
        address: 'Via Loco 15A, 6963 Pregassona',
        warning: '',
        checkin: 'Der Check-in ist ab 15:00 Uhr möglich.',
        parking: 'Wenn Sie das Auto parken müssen, steht ein privater Innenparkplatz (Garage) vor Ort zur Verfügung. Wenn Sie die Garage vollständig schließen, müssen Sie sie mit dem Schlüssel öffnen. Die Garagenschlüssel befinden sich zusammen mit den Wohnungsschlüsseln. Die Garage ist 2 Meter hoch und 2,30 Meter breit. Alternativ gibt es sehr nahe der Wohnung (etwas oberhalb in der Straße) blaue öffentliche Parkplätze (mit eingeschränkten Zeiten).',
        transport: 'Sie können auch den Bus Nr. 7 von "Pregassona, Viarnetto" oder "Pregassona, Piazza di giro" nehmen, der 5 Gehminuten entfernt ist und 10 Minuten bis ins Zentrum von Lugano braucht. Die Busse fahren alle 15 Minuten.',
      },
      fr: {
        address: 'Via Loco 15A, 6963 Pregassona',
        warning: '',
        checkin: 'L\'enregistrement est possible à partir de 15h00.',
        parking: 'Si vous avez besoin de garer la voiture, un parking privé couvert (garage) est disponible sur place. Si vous fermez complètement le garage, vous devrez l\'ouvrir avec les clés. Les clés du garage sont avec celles de l\'appartement. Le garage fait 2 mètres de haut et 2,30 mètres de large. Alternativement, très proche de l\'appartement (juste au-dessus dans la rue) il y a des places de parking public bleues (avec des horaires restreints).',
        transport: 'Vous pouvez aussi prendre le bus n° 7 depuis "Pregassona, Viarnetto" ou "Pregassona, Piazza di giro" qui se trouve à 5 minutes à pied et met 10 minutes pour rejoindre le centre de Lugano. Les passages sont toutes les 15 minutes.',
      },
    },
  },
  emerald: {
    name: 'Emerald Apartment',
    code: '0426',
    safeboxImage: '/emerald_mailbox.png',
    mapsLink: 'https://maps.app.goo.gl/UtNGrQjuxqckV34V7?g_st=aw',
    parkingMapsLink: '',
    photos: [
      'https://customer-assets.emergentagent.com/job_homewise-ticino/artifacts/tc4slvgx_1.webp',
      '/emerald_mailbox.png',
      'https://customer-assets.emergentagent.com/job_homewise-ticino/artifacts/qiokadl1_3.png',
    ],
    instructions: {
      it: {
        address: 'Via Luigi Lavizzari 18, 6900 Lugano',
        warning: '',
        checkin: 'Il check-in è possibile a partire dalle ore 15:00.',
        parking: 'Il parcheggio privato è disponibile nel garage dell\'edificio. Il posto auto riservato per te è il nr. A13, dove troverai anche il cartello "EMERALD APARTMENT" sulla parete. Vedi tutte le foto allegate con le istruzioni.',
        transport: 'L\'appartamento si trova nel centro città, a pochi passi da tutte le attrazioni, Parco Ciani, bar, ristoranti e negozi.',
        floor: 'L\'appartamento è situato al primo piano. La porta ha un\'etichetta con scritto "Emerald Apartment".',
      },
      en: {
        address: 'Via Luigi Lavizzari 18, 6900 Lugano',
        warning: '',
        checkin: 'You can check-in starting from 3 PM.',
        parking: 'The private parking is available inside the garage of the building. The parking reserved for you is nr. A13, where you will also see the sign "EMERALD APARTMENT" on the wall. See all pictures attached with all instructions.',
        transport: 'The apartment is in the city center, at a walking distance from all attractions, Parco Ciani, bars, restaurants and shops.',
        floor: 'The apartment is located on the 1st floor. The door has a sign that says "Emerald Apartment".',
      },
      de: {
        address: 'Via Luigi Lavizzari 18, 6900 Lugano',
        warning: '',
        checkin: 'Der Check-in ist ab 15:00 Uhr möglich.',
        parking: 'Der private Parkplatz befindet sich in der Tiefgarage des Gebäudes. Der für Sie reservierte Parkplatz ist Nr. A13, wo Sie auch das Schild "EMERALD APARTMENT" an der Wand sehen. Sehen Sie alle Fotos mit Anweisungen.',
        transport: 'Die Wohnung befindet sich im Stadtzentrum, in Gehweite von allen Sehenswürdigkeiten, dem Parco Ciani, Bars, Restaurants und Geschäften.',
        floor: 'Die Wohnung befindet sich im ersten Stockwerk. An der Tür befindet sich ein Schild mit der Aufschrift "Emerald Apartment".',
      },
      fr: {
        address: 'Via Luigi Lavizzari 18, 6900 Lugano',
        warning: '',
        checkin: 'L\'enregistrement est possible à partir de 15h00.',
        parking: 'Le parking privé est disponible dans le garage de l\'immeuble. La place qui vous est réservée est la n° A13, où vous verrez aussi le panneau "EMERALD APARTMENT" sur le mur. Voir toutes les photos jointes avec les instructions.',
        transport: 'L\'appartement est en centre-ville, à distance de marche de toutes les attractions, du Parco Ciani, des bars, restaurants et boutiques.',
        floor: 'L\'appartement est situé au premier étage. La porte comporte une étiquette indiquant "Emerald Apartment".',
      },
    },
  },
  crisalide: {
    name: 'Rustico La Crisalide',
    code: '0526',
    safeboxImage: '/crisalide_safebox.png',
    mapsLink: 'https://maps.app.goo.gl/BTG13oFiWyPjZiER9',
    parkingMapsLink: '',
    photos: [
      'https://customer-assets.emergentagent.com/job_homewise-ticino/artifacts/1qx6j99r_Parking%20garage%20on%20the%20right%20%282%29.png',
      'https://customer-assets.emergentagent.com/job_homewise-ticino/artifacts/3oeny965_6.png',
    ],
    instructions: {
      it: {
        address: 'Via Bernardo Peyer 7, 6866 Meride',
        warning: '',
        checkin: 'Il check-in è possibile a partire dalle ore 15:00.',
        parking: 'Il parcheggio pubblico è disponibile a 40 metri dall\'appartamento. La tariffa è di CHF 1.50 all\'ora durante il giorno (08:00 - 19:00). Non è possibile prenotarlo in anticipo poiché è un parcheggio pubblico.',
        transport: 'L\'appartamento si trova nel centro del vecchio villaggio, a pochi passi da tutte le attrazioni, il Museo dei Fossili e il Monte San Giorgio (UNESCO).',
      },
      en: {
        address: 'Via Bernardo Peyer 7, 6866 Meride',
        warning: '',
        checkin: 'You can check-in starting from 3 PM.',
        parking: 'The public parking is available 40 meters from the apartment. The fee is CHF 1.50 per hour during the day time (08:00 - 19:00). It\'s not possible to book it in advance, since the parking is public.',
        transport: 'The apartment is in the old village center, at a walking distance from all attractions, Museo dei Fossili and Monte San Giorgio (UNESCO).',
      },
      de: {
        address: 'Via Bernardo Peyer 7, 6866 Meride',
        warning: '',
        checkin: 'Der Check-in ist ab 15:00 Uhr möglich.',
        parking: 'Der öffentliche Parkplatz befindet sich 40 Meter von der Wohnung entfernt. Die Gebühr beträgt CHF 1.50 pro Stunde tagsüber (08:00 - 19:00). Eine Reservierung ist nicht möglich, da der Parkplatz öffentlich ist.',
        transport: 'Die Wohnung befindet sich im historischen Dorfzentrum, in Gehweite aller Sehenswürdigkeiten, des Fossilienmuseums und des Monte San Giorgio (UNESCO).',
      },
      fr: {
        address: 'Via Bernardo Peyer 7, 6866 Meride',
        warning: '',
        checkin: 'L\'enregistrement est possible à partir de 15h00.',
        parking: 'Le parking public est disponible à 40 mètres de l\'appartement. Le tarif est de CHF 1.50 par heure en journée (08:00 - 19:00). Il n\'est pas possible de le réserver à l\'avance car le parking est public.',
        transport: 'L\'appartement se trouve dans le centre de l\'ancien village, à distance de marche de toutes les attractions, du Museo dei Fossili et du Monte San Giorgio (UNESCO).',
      },
    },
  },
};

const COMMON_TRANSLATIONS = {
  it: {
    welcome: 'Benvenuto in Homewise',
    welcomeSub: 'Siamo felici del tuo prossimo arrivo! Ecco tutto ciò che ti serve per il tuo soggiorno.',
    safeboxTitle: 'Codice della Safebox',
    safeboxSave: 'IMPORTANTE: salva o memorizza questo codice. Ti consigliamo di fare uno screenshot.',
    instructionsTitle: 'Informazioni per il soggiorno e l\'arrivo all\'appartamento',
    addressLabel: 'Indirizzo',
    openMaps: 'Apri su Google Maps',
    parkingTitle: 'Parcheggio',
    parkingMaps: 'Posizione parcheggio privato',
    transportTitle: 'Trasporti pubblici',
    contactTitle: 'Hai bisogno di aiuto?',
    contactPrefer: 'Preferibilmente tramite messaggio o WhatsApp.',
    contactUrgent: 'Se Simone non fosse disponibile, SOLO per urgenze:',
    checkoutReminder: 'Ricordiamo gentilmente che il check-out è entro le ore 10:00 del giorno di partenza.',
    checkinTitle: 'Check-in',
    photosTitle: 'Foto e indicazioni',
    paymentConfirmed: 'Pagamento della tassa di soggiorno confermato',
  },
  en: {
    welcome: 'Welcome to Homewise',
    welcomeSub: 'We are happy about your upcoming arrival! Here is everything you need for your stay.',
    safeboxTitle: 'Safebox Code',
    safeboxSave: 'IMPORTANT: save or memorize this code. We recommend taking a screenshot.',
    instructionsTitle: 'Arrival instructions and stay information',
    addressLabel: 'Address',
    openMaps: 'Open on Google Maps',
    parkingTitle: 'Parking',
    parkingMaps: 'Private parking location',
    transportTitle: 'Public transport',
    contactTitle: 'Need help?',
    contactPrefer: 'Preferably via message or WhatsApp.',
    contactUrgent: 'If Simone is not available, for urgent cases ONLY:',
    checkoutReminder: 'We kindly remind you that the check-out is by 10:00 AM on the departure day.',
    checkinTitle: 'Check-in',
    photosTitle: 'Photos and directions',
    paymentConfirmed: 'Tourist tax payment confirmed',
  },
  de: {
    welcome: 'Willkommen bei Homewise',
    welcomeSub: 'Wir freuen uns auf Ihre Ankunft! Hier finden Sie alles, was Sie für Ihren Aufenthalt brauchen.',
    safeboxTitle: 'Safebox-Code',
    safeboxSave: 'WICHTIG: Speichern oder merken Sie sich diesen Code. Wir empfehlen einen Screenshot.',
    instructionsTitle: 'Ankunftsinformationen und Aufenthaltsinformationen',
    addressLabel: 'Adresse',
    openMaps: 'Auf Google Maps öffnen',
    parkingTitle: 'Parkplatz',
    parkingMaps: 'Position des Privatparkplatzes',
    transportTitle: 'Öffentliche Verkehrsmittel',
    contactTitle: 'Brauchen Sie Hilfe?',
    contactPrefer: 'Vorzugsweise per Nachricht oder WhatsApp.',
    contactUrgent: 'Wenn Simone nicht verfügbar ist, NUR für Notfälle:',
    checkoutReminder: 'Wir erinnern freundlich daran, dass der Check-out bis 10:00 Uhr am Abreisetag erfolgen muss.',
    checkinTitle: 'Check-in',
    photosTitle: 'Fotos und Wegbeschreibung',
    paymentConfirmed: 'Zahlung der Kurtaxe bestätigt',
  },
  fr: {
    welcome: 'Bienvenue chez Homewise',
    welcomeSub: 'Nous sommes ravis de votre prochaine arrivée! Voici tout ce dont vous avez besoin pour votre séjour.',
    safeboxTitle: 'Code de la Safebox',
    safeboxSave: 'IMPORTANT: sauvegardez ou mémorisez ce code. Nous vous recommandons de faire une capture d\'écran.',
    instructionsTitle: 'Instructions d\'arrivée et informations sur le séjour',
    addressLabel: 'Adresse',
    openMaps: 'Ouvrir sur Google Maps',
    parkingTitle: 'Parking',
    parkingMaps: 'Position du parking privé',
    transportTitle: 'Transports publics',
    contactTitle: 'Besoin d\'aide?',
    contactPrefer: 'De préférence par message ou WhatsApp.',
    contactUrgent: 'Si Simone n\'est pas disponible, UNIQUEMENT pour les urgences:',
    checkoutReminder: 'Nous vous rappelons aimablement que le check-out est avant 10h00 le jour du départ.',
    checkinTitle: 'Check-in',
    photosTitle: 'Photos et indications',
    paymentConfirmed: 'Paiement de la taxe de séjour confirmé',
  },
};

export { APARTMENT_DATA, COMMON_TRANSLATIONS };
